import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate"
export default createStore({
  state: {
    userdata: [],
    loginType: 'false',
    NavIndex: '1'
  },
  mutations: {
    userdata: (state, n) => {
      //传入登录状态islogin
      state.userdata = n;
    },
    loginType: (state, data) => {
      //登录状态
      state.loginType = data
    },
    NavIndex: (state, data) =>{
      state.NavIndex = data
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
